module.exports = new __parcel__URL__("east_coast_mar_20.3d5326cb.jpg").toString();